import { BaseSyntheticEvent, useState } from 'react';
import { SubmitErrorHandler, SubmitHandler, UseFormHandleSubmit } from 'react-hook-form';

import { useThrottleCallback } from '@flipster/react/misc/throttle';

export function useHandleSubmit<T extends Record<string, unknown>>(
  handleSubmit: UseFormHandleSubmit<T>,
  onValid: SubmitHandler<T>,
  onInValid?: SubmitErrorHandler<T>,
) {
  const [isLoading, setIsLoading] = useState(false);

  const onThrottleValid = useThrottleCallback(async (data: T, e: BaseSyntheticEvent | undefined) => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      await onValid(data, e);
    } finally {
      setIsLoading(false);
    }
  });

  const onThrottleInValid: SubmitErrorHandler<T> = useThrottleCallback(onInValid);

  return [isLoading, handleSubmit(onThrottleValid, onThrottleInValid)] as const;
}
